import type { TLockersResponse } from "../models/lockers";
import type { TLockerEntry } from "../types";

const mapLockersResponse = (response: TLockersResponse): TLockerEntry[] =>
  (response || []).map((locker) => ({
    id: locker.id,
    name: locker.name,
    street: locker.address.street,
    city: locker.address.city,
    country: locker.address.country,
    postalCode: locker.address.postalCode,
  }));

export default mapLockersResponse;
